export default __webpack_public_path__ + "static/media/7minfitness_7@3x.618e1c78.jpg";